import {
  WalletTransactionApiRow,
  WalletTransactionType,
} from "../../../../../models/Swagstore/SwagstoreWalletTransactions";

export const isCreditTransaction = (type: WalletTransactionType) =>
  type === WalletTransactionType.CREDIT;

export const formatTransactionPerformedBy = (row: WalletTransactionApiRow) =>
  row.performed_by_user_name || row.admin_name || "—";

export const formatTransactionSource = (source: string | null) => {
  if (!source) return "—";
  return source
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
